import React from "react";
import {css} from "@emotion/css";
import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined
} from "@moeindal/base-raiko-panel-components";

export default function CreatorInfo(
    {
        createdBy = "",
        createdAt = "",
    }) {


    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoSectionContainer
                    title={"اطلاعات ساخت"}
                >
                    <RaikoGridTwoColumn className={css`margin-top: .25rem`}>

                        <RaikoSimpleInputOutlined
                            labelText={"سازنده"}
                            setValue={_ => {
                            }}
                            value={createdBy}
                            disabled={true}/>

                        <RaikoSimpleInputOutlined
                            labelText={"تاریخ ساخت"}
                            setValue={_ => {
                            }}
                            value={createdAt}
                            disabled={true}/>

                    </RaikoGridTwoColumn>
                </RaikoSectionContainer>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )

}
